import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ConfigurationService } from '@urbannex/configuration';
import { OfbizFormsService } from '@urbannex/ofbiz-forms';
import { GridCell, RowCell, Section, ContentElement, ContentEnum, ContentElementEnum, ContentStatusEnum } from '@urbannex/storethemes';
import { SectionBuilderStoreService } from '../../section-builder-store.service';

@Component({
  selector: 'kve-call-to-action-cell-stepper',
  templateUrl: './call-to-action-cell-stepper.component.html',
  styleUrls: ['./call-to-action-cell-stepper.component.scss']
})
export class CallToActionCellStepperComponent implements OnChanges {
  @Input() cell:GridCell | RowCell;
  @Input() section:Section;

  contentElements:ContentElement[];
  stepperTitle:string;
  lastStep = false;
  firstStep = true;
  showPlaceholder: boolean = true;
  baseUrl:string;

  imgSrc: string;

  contentEnum:ContentEnum;
  cntElementEnum = ContentElementEnum;
  currentCntElementEnum:ContentElementEnum;

  cntElementSteps:ContentElement[];

  mode:string;

  @Output() closeHostDialog = new EventEmitter<void>()

  constructor(
    private ofbizFormsService:OfbizFormsService,
    private sectionBuilderStoreService:SectionBuilderStoreService,
    private configurationService:ConfigurationService,
    ){}

    ngOnChanges(changes: SimpleChanges): void {
      if(changes["cell"]){
        this.contentElements = this.cell.contentElements;
        this.cntElementSteps = this.convertElementsToSteps(this.cell.contentElements);
        this.contentEnum = this.cell.contentEnum;
        this.imgSrc = this.cell.imgSrc;
        this.stepperTitle = this.getStepperTitle(this.contentEnum)
      }
    }

    getStepperTitle(titleEnum){
      let title;
      if((titleEnum).includes(".")){
        let enumKey = titleEnum.split('.')[1] as keyof typeof ContentEnum;
        title = ContentEnum[enumKey];
      }else if(ContentEnum[titleEnum] != undefined){
        title = ContentEnum[titleEnum]
      }else{
        title = titleEnum;
      }
      
      console.log(title)
      
      return title;
    }

    populateContentElements(fields:any[]):void{
      //Product Name;
      //Price
      //Discount
      //Category
      //Release
      //Normal Price
      //Quick View
      //Release
      //Add to wish list
      //Add to cart
      console.log(this.contentElements);
      let productName = this.getFieldValue("productName",fields);
      console.log(productName);
      let productNameContentEl = this.contentElements.find(cntlEl => cntlEl.fieldName == "productName" || cntlEl.name == "Product Name");
      console.log(productNameContentEl);
      this.contentElements.forEach(contentElement => {
        if(contentElement.fieldName == "productName" || contentElement.name == "Product Name"){
          contentElement.text = this.getFieldValue("productName",fields);
          console.log(contentElement)
        }
        if(contentElement.fieldName == "price" || contentElement.name == "Price"){
          contentElement.text = this.getFieldValue("price",fields);
          console.log(contentElement)
        }
      })
      console.log(fields);
      
  
  
    }

    getFieldValue(nameKey, fields:any[]){
      let value;
        for (let i=0; i < fields.length; i++) {
          for (let [k,v] of Object.entries(fields[i])) {
            if(k == nameKey){
              //value =  fields[i][k];
              value = v
            }
          }
        }
      return value
    }

    onStepChange(e){
      if(e.index == (e.step.stepper.steps.length - 1)){
        this.lastStep = true;
      }
      if(e.index > 0){
        this.firstStep = false;
      }
    }

    getEnumValue(contentElement:ContentElement){
      let enumValue:string;
      let titleEnum = contentElement.contentElementEnum
      if(titleEnum != undefined){
        if((titleEnum).includes(".")){
          let enumKey = titleEnum.split('.')[1] as keyof typeof ContentElementEnum;
          enumValue = ContentElementEnum[enumKey];
        }else if(ContentElementEnum[titleEnum] != undefined){
          enumValue = ContentElementEnum[titleEnum]
        }else{
          enumValue = titleEnum;
        }
      }
      if(enumValue) enumValue = <string>enumValue.toUpperCase();
      
      return enumValue;
    }

    onSubmitContent(){
      console.log("onSubmitContent")
      this.cell.status = ContentStatusEnum.CTNT_INITIAL_DRAFT;
      this.section.status = ContentStatusEnum.CTNT_INITIAL_DRAFT;
      this.sectionBuilderStoreService.updateSection(this.section);
      this.sectionBuilderStoreService.updateSelectedCell(this.cell);
      this.closeHostDialog.emit();
    }

    convertElementsToSteps(contentElements:ContentElement[]):ContentElement[]{
      console.log(contentElements);
      let cntElementSteps = [];

      if(contentElements.length > 0){
        let headerEl = contentElements.find((cntlEl:any) => cntlEl.contentElementEnum == ContentElementEnum.HEADER);
        if(headerEl){
          cntElementSteps.push(headerEl)
        }
        let descEl = contentElements.find((cntlEl:any) => cntlEl.contentElementEnum == ContentElementEnum.TEXT);
        if(descEl){
          cntElementSteps.push(descEl)
        }
        let inputEl = contentElements.find((cntlEl:any) => cntlEl.contentElementEnum == ContentElementEnum.INPUTFIELD);
        if(inputEl){
          cntElementSteps.push(inputEl)
        }
      }
      
      console.log(cntElementSteps)
      return cntElementSteps
    }

}
